import { gsap } from "gsap";

const setupHeaderAnimations = () => {
  const header = document.getElementById("site-header");

  if (header) {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 50) {
        gsap.to(header, {
          backgroundColor: "#ffffff",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          duration: 0.3,
        });
      } else {
        gsap.to(header, {
          backgroundColor: "transparent",
          boxShadow: "none",
          duration: 0.3,
        });
      }
    });
  }
};

export default setupHeaderAnimations;
